import React, { FC, useCallback } from 'react';
import { DataGrid, GridPaginationModel, GridToolbar } from '@mui/x-data-grid';
import { useAppDispatch, useAppSelector } from 'hooks';
import { DataStatus } from 'types/enums';
import { COLUMNS } from './constants';
import { Box } from '@mui/material';
import { tokens } from 'theme';
import { ScreenTitle } from 'components';
import { useTheme } from 'hooks';
import { RequestResponseDto } from 'types/types';
import { requestsActions } from 'utils/store/slice';
import { RequestRefineItems } from './components';
import styles from './styles.module.sass';

export const RequestsTable: FC = () => {
  const { status, requests, totalCount } = useAppSelector((state) => state.requests);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isDataLoading = status === DataStatus.LOADING;
  const dispatch = useAppDispatch();

  const handlePaginationChange = (paginationModel: GridPaginationModel) => {
    const { page, pageSize } = paginationModel;
    const skip = page * pageSize;
    dispatch(requestsActions.setLimit(pageSize));
    dispatch(requestsActions.setSkip(skip));
    dispatch(requestsActions.getPaginatedRequests());
  };

  const handleRowClick = useCallback(
    (request: RequestResponseDto) => {
      dispatch(requestsActions.setAnalyzedRequest(request));
    },
    [dispatch],
  );

  return (
    <>
      <ScreenTitle title='Requests' />
      <Box
        className={styles.details}
        sx={{
          '& .MuiDataGrid-root': {
            border: 'none',
            overflowY: 'hidden',
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
            width: '0.4em',
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
            background: '#f1f1f1',
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
            backgroundColor: colors.dashboard.secondary,
          },
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: colors.dashboard.secondary,
            borderBottom: 'none',
          },
          '& .MuiDataGrid-footerContainer': {
            borderTop: 'none',
            backgroundColor: colors.dashboard.secondary,
          },
          '& .MuiCheckbox-root': {
            color: `${colors.greenAccent[200]} !important`,
          },
          '& .MuiDataGrid-toolbarContainer .MuiButton-text': {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <RequestRefineItems />
        <DataGrid
          rowHeight={100}
          onRowClick={({ row }: { row: RequestResponseDto }) => handleRowClick(row)}
          rows={requests}
          columns={COLUMNS}
          initialState={{
            pagination: { paginationModel: { pageSize: 20 } },
          }}
          pageSizeOptions={[10, 20, 50]}
          sx={{ overflowX: 'auto' }}
          slots={{ toolbar: GridToolbar }}
          slotProps={{ toolbar: { showQuickFilter: true } }}
          loading={isDataLoading}
          onPaginationModelChange={handlePaginationChange}
          paginationMode='server'
          rowCount={totalCount}
        />
      </Box>
    </>
  );
};
